<!--
 * =====================================================================
 * 작 업 명  : 회원정보수정
 * 파 일 명  : Edit.vue
 * 변경이력
 * 2022-02-11 / 임태민 / 최초작성
 * =====================================================================
 -->
<template>
	<h3 class="title mt-5 text-center">
		<button class="btn rounded-circle border-0 bg-whites" @click="arrowClick()">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="32"
				height="42"
				fill="currentColor"
				class="bi bi-arrow-left-short"
				viewBox="0 0 16 16"
			>
				<path
					fill-rule="evenodd"
					d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
				></path>
			</svg>
		</button>
        Manage basic info
	</h3>
	<div class="border-bottom mb-4"></div>
	<h6 class="title mb-4 text-center">
		Some info may be visible to other people using Dot services.
	</h6>
	<div class="row mb-4">
		<div class="col-sm-4"></div>
		<div class="col-sm-4 list-group-item rounded-3">
			<div class="text mt-4 mb-3"><h5>Choose what info to show</h5></div>
			<div class="row">
				<!-- NICK_NAME -->
				<div class="col mt-3 mb-3">
					<div class="form-floating">
						<input
							type="text"
							class="form-control"
							id="nickname"
							v-model="this.user.NICK_NAME"
						/>
						<label for="nickname">Nickname</label>
					</div>
                    <div ref="NICK_NAME" class="check red" role="alert">&nbsp;</div>
				</div>

				<!-- SEX_TYPE -->
				<div class="col mt-3 mb-3">
					<div class="form-floating">
						<select class="form-select" id="sex" v-model="this.user.SEX_TYPE">
							<option value="" selected disabled>Select your gender</option>
							<option value="M">Male</option>
							<option value="F">Female</option>
							<option value="X">Unchecked</option>
						</select>
						<label for="sex">Gender</label>
					</div>
				</div>
			</div>
			<div class="row">
				<!-- MOBILE -->
				<div class="col mb-3">
					<div class="form-floating">
						<input
							type="text"
							class="form-control"
							id="mobile"
							v-model="this.user.MOBILE"
							placeholder="000-0000-0000"
							maxlength="13"
						/>
						<label for="mobile">Mobile (000-0000-0000)</label>
						<div ref="MOBILE" class="check red" role="alert">&nbsp;</div>
					</div>
				</div>

				<!-- TEL -->
				<div class="col mb-3">
					<div class="form-floating">
						<input
							type="text"
							class="form-control"
							id="telephone"
							v-model="this.user.TEL"
							placeholder="000-0000-0000"
							maxlength="13"
						/>
						<label for="telephone">Tel (000-0000-0000)</label>
						<div ref="TEL" class="check red" role="alert">&nbsp;</div>
					</div>
				</div>
			</div>
			<div class="row">
				<!-- BIRTH_TYPE -->
				<div class="col mb-3">
					<div class="form-floating">
						<select class="form-select" id="birthday-type" v-model="this.user.BIRTH_TYPE">
							<option value="S">Solar</option>
							<option value="L">Lunar</option>
						</select>
						<label for="birthday-type">Birth type</label>
					</div>
				</div>
				<!-- BIRTH DATE -->
				<div class="col mb-3">
					<div class="form-floating">
						<input
							type="text"
							class="form-control"
							id="birth-day"
							v-model="this.user.BIRTH_DAY"
							placeholder="YYYYMMDD"
							maxlength="10"
						/>
						<label for="birth-day">Birth Date(YYYYMMDD)</label>
						<div ref="BIRTH_DAY" class="check red" role="alert">&nbsp;</div>
					</div>
				</div>
			</div>
			<div class="col mb-3">
				<div class="form-floating">
					<input
						type="text"
						class="form-control"
						id="addr1"
						v-model="this.user.ADDR1"
					/>
					<label for="addr1">Address 1</label>
				</div>
			</div>
			<div class="col mb-3">
				<div class="form-floating">
					<input
						type="text"
						class="form-control"
						id="addr2"
						v-model="this.user.ADDR2"
					/>
					<label for="addr2">Address 2</label>
				</div>
			</div>
			<div class="row">
				<div class="col mb-3">
					<div class="form-floating">
						<input
							type="text"
							class="form-control"
							id="area"
							v-model="this.user.AREA"
							maxlength="3"
						/>
						<label for="area">State/Province</label>
					</div>
				</div>
				<div class="col mb-3">
					<div class="form-floating">
						<input
							type="text"
							class="form-control"
							id="zip-code"
							v-model="this.user.ZIP_CODE"
							placeholder="12345-1234"
							maxlength="10"
						/>
						<label for="zip-code">Zip(12345-1234)</label>
						<div ref="ZIP_CODE" class="check red" role="alert">&nbsp;</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-6">
					<div ref="ERROR" class="check" role="alert">&nbsp;</div>
				</div>
			</div>
			<div class="row">
				<div class="col mb-2 d-flex justify-content-end">
					<button type="button" class="btn btn-dark" @click="editClick()">
						Save
					</button>
				</div>
			</div>
		</div>
		<div class="col-sm-4"></div>
	</div>
</template>
<script>
import { router } from "@/routes/index.js";
import { $global } from "@/js/global.js";
import { $axios, $error } from "@/dot-ui/index.js";
import { Join } from "@/js/user/Join.js";

export default {
	data() {
		return {
			user: {
				USER_NO: sessionStorage.getItem("USER_NO"),
				USER_ID: sessionStorage.getItem("USER_ID"),
				FIRST_NAME: "",
				LAST_NAME: "",
				NICK_NAME: "",
				USER_TYPE: "",
				MOBILE: "",
				BIRTH_DAY: "",
				BIRTH_TYPE: "",
				SEX_TYPE: "",
				ZIP_CODE: "",
				ADDR1: "",
				ADDR2: "",
				TEL: "",
				AREA: "",
				EMAIL: "",
			},
			fromParams: "",
		};
	},
	created()
    {
		this.fromParams = $global.getUrlParams();
	},
	mounted()
    {
		this.search();
	},
	methods:
    {
		async search()
        {
			let frmoSiteNo = this.fromParams.s;
			let fromCompNo = this.fromParams.c;
			let url = "/user-app/v1/sites/" + frmoSiteNo + "-" + fromCompNo + "/users/" + this.user.USER_NO;
			let response = await $axios.get(url, {}, true);

			if (response.status == 200) {
				this.user = response.data;
			}
		},
		// 회원정보수정 클릭
		async editClick()
        {
            $error.clearForm("check"); // 클래스(.check) 폼 초기화

			let siteNo = this.fromParams.s;
			let compNo = this.fromParams.c;
			let url = "/user-app/v1/sites/" + siteNo + "-" + compNo + "/users/" + this.user.USER_NO + "/editUser";
			let param = this.user;
			let response = await $axios.put(url, param);

			if (response.status == 200) {
				let json = response.data;
				if (json.RESULT_CODE == "1") {
                    this.$refs.ERROR.innerHTML = "information has been modified.";
                    Join.setColorClass(this.$refs.ERROR, "blue");
				}
			} else {
                $error.showMessage(response, this);
            }
		},
		// 뒤로가기 클릭
		arrowClick()
        {
            router.push({
                path: "/basic",
                query: {
                    cb: this.fromParams.cb,
                    s: this.fromParams.s,
                    c: this.fromParams.c,
                },
            });
		},
	},
};
</script>
<style>
.red {
  color: red;
}
.blue {
  color: blue;
}
.black {
  color: black;
}
</style>
